<template>
  <div>
    <!-- 是否付款 -->
    <div class="isFlag" v-if="flag">
      <span></span>
      <p>{{ flag?title[0]:title[1] }}</p>
    </div>
    <!-- 是否发货 -->
    <div class="noFlag" v-else>
      <span></span>
      <p>{{ flag?title[0]:title[1] }}</p>
    </div>
  </div>
</template>

<script>
export default {
    props:['flag','title']
};
</script>

<style lang="less" scoped>
.isFlag {
  width: 59px;
  height: 24px;
  background: rgba(223, 227, 232, 1);
  border-radius: 12px;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 13px;
  font-size: 12px;
  > span:first-child {
    width: 12px !important;
    height: 12px;
    box-sizing: border-box;
    border: 4px solid #999;
    display: inline-block;
    border-radius: 50%;
  }
  > p {
    display: inline-block;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-left: 10px;
  }
}
.noFlag {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  background: rgba(183, 217, 255, 1);
  border-radius: 12px;
  padding: 0 13px;
  font-size: 12px;
  > span:first-child {
    width: 12px !important;
    height: 12px;
    border: 2px solid #0077ff;
    box-sizing: border-box;
    display: inline-block;
    border-radius: 50%;
  }
  > p {
    display: inline-block;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-left: 10px;
  }
}
</style>